module.exports = __webpack_public_path__ + "img/ZeroPieceS1Page.4eae5cdf.png";